import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAddresses, deleteAddress } from './../../../reducers/addresses';
import { history } from './../../../configuration/store';
import { FormattedMessage } from 'react-intl';

import './addresses.css';

class AddressList extends React.Component {
    constructor(props) {
        super(props);

        this.resolveAddressKind = this.resolveAddressKind.bind(this);
    }

    resolveAddressKind(kind) {
        switch (kind) {
            case 'l':
                return <FormattedMessage id={'additionalLocation'} defaultMessage={'Other'} />;

            case 'm':
                return <FormattedMessage id={'mailingAddress'} defaultMessage={'Mailing'} />;

            default:
            case 'p':
                return <FormattedMessage id={'primaryAddress'} defaultMessage={'Primary'} />;
        }
    }

    componentDidMount() {
        let { role, getAddresses } = this.props;
        if (role) {
            getAddresses(role);
        }
    }

    render() {
        const { addresses, deleteAddress } = this.props;
        return (
            <div className="row">
                <div className="col-xs-12 address-item" onClick={() => history.push('/address/new')}>
                    <div className="row">
                        <span className="address-create col-xs-12">
                            <i className="material-icons">add_box</i>
                            <FormattedMessage id={'createAddress'} defaultMessage={'Create a new address'} />
                        </span>
                    </div>
                </div>
                {addresses.map((address, i) => {
                    return (
                        <div className="col-xs-12 address-item" key={i}>
                            <div className="row">
                                <div className="col-md-5 col-xs-10" onClick={() => history.push('/address/' + address.id)}>
                                    <span className="address-name">{address.name}</span>
                                    <span className="address-info">
                                        {address.street}
                                        {address.street2 && `, ${address.street2}`}
                                    </span>
                                </div>
                                <span className="address-info col-md-3 col-xs-4">
                                    {address.city}, {address.state}, {address.zip}
                                </span>
                                <span className="address-info col-xs-2">{this.resolveAddressKind(address.kind)}</span>
                                <div className="pull-right item-action" onClick={() => deleteAddress(address.id)}>
                                    <i className="far fa-trash-alt" />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

AddressList.defaultProps = {
    role: undefined,
    addresses: []
};

AddressList.propTypes = {
    role: PropTypes.object,
    addresses: PropTypes.array
};

const mapStateToProps = state => ({
    addresses: state.addresses.list,
    role: state.identity.role
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAddresses: getAddresses,
            deleteAddress: deleteAddress
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AddressList);



// WEBPACK FOOTER //
// ./src/components/lists/addresses/index.jsx